export default __webpack_public_path__ + "static/media/lideranca-agil.3963b903.png";